import formatStateroomsInput from '../formatStateroomsInput';

const checkIfNewFlightSearch = (searchInputs, searchObj) => (searchInputs && searchInputs.flight
  && searchObj && searchObj.flight)
  && (JSON.stringify(searchInputs.flight.flightSegments)
    !== JSON.stringify(searchObj.flight.flightSegments)
    || formatStateroomsInput(searchInputs.staterooms)
    !== formatStateroomsInput(searchObj.staterooms)
    || searchInputs.flight.flightSearchType !== searchObj.flight.flightSearchType
    || JSON.stringify(searchInputs.flight.airlines) !== JSON.stringify(searchObj.flight.airlines)
    || searchInputs.flight.maxNumOfStops !== searchObj.flight.maxNumOfStops
    || searchInputs.flight.avoidCabinDowngrade !== searchObj.flight.avoidCabinDowngrade
    || searchInputs.flight.keepSameCabin !== searchObj.flight.keepSameCabin
    || JSON.stringify(searchInputs.flight.rateCodes) !== JSON.stringify(searchObj.flight.rateCodes)
    || (searchInputs.flight.doShowRefundableFlightsOnly || false)
    !== (searchObj.flight.doShowRefundableFlightsOnly || false)
    || (searchInputs.flight.doShowLongConnectFlights || false)
      !== (searchObj.flight.doShowLongConnectFlights || false)
    || (searchInputs.flight.doHideNdcFares || false)
      !== (searchObj.flight.doHideNdcFares || false)
    || (searchInputs.flight.doEnableFlightsPolling || false)
      !== (searchObj.flight.doEnableFlightsPolling || false));

export default checkIfNewFlightSearch;
